import { Navigate, Outlet } from 'react-router-dom'

import { MAIN_ROUTE } from '../../utils/constants'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../store/slices/currentUserSlice'

export const Protected = () => {
  const currentUser = useSelector(selectCurrentUser)

  if (currentUser) {
    return <Outlet />
  } else {
    return <Navigate to={MAIN_ROUTE} />
  }
}
